module.exports = __webpack_public_path__ + "static/media/Real_core.29e0292a.png";